import React, { FC, useEffect, useState } from "react";
import { Card, Collapse } from "react-bootstrap";
import { AssetBundle, MutatorProperty } from "../../../models/types";
import { AssetbundleDropdown } from "../../dropdowns/mutator/AssetbundleDropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { useMutatorState } from "../../../graphql/hooks";
import { useTypeCardVariant } from "./leftBorderStyle";
import styles from "./CustomTypeCard.module.scss";
import cx from "classnames";

interface Props {
    property: MutatorProperty;
    assetbundles: AssetBundle[];
    getVariantByType: (type: string) => string;
    onChange: (name: string, value: string) => void;
}

const AssetbundleCardImplementation: FC<Props> = ({
    property,
    assetbundles,
    getVariantByType,
    onChange
}) => {
    const mutatorState = useMutatorState();
    const { cardClassName, renderTypeBadge } = useTypeCardVariant(
        property.type,
        getVariantByType
    );
    const [showMeta, updateShowMeta] = useState(mutatorState.showMeta);

    useEffect(() => {
        if (showMeta !== mutatorState.showMeta) {
            updateShowMeta(mutatorState.showMeta);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mutatorState.showMeta]);

    const allowedAssetbundles =
        property?.meta?.path !== undefined
            ? assetbundles.filter(element => {
                  return (
                      element.path.split("/")[0] === property.meta?.path ||
                      false
                  );
              })
            : assetbundles;
    return (
        <Card className={`text-contrast inner-card m-2 ${cardClassName}`}>
            <Card.Header
                className={`d-flex align-items-center ${styles.cardHeader}`}
            >
                <span className={styles.headerText}>{property.name}</span>
                {renderTypeBadge()}
                {property.meta ? (
                    <div
                        className="float-end mouseHover ms-auto"
                        onClick={() => updateShowMeta(!showMeta)}
                        title="Help and additional info"
                    >
                        <FontAwesomeIcon
                            icon={faCircleInfo}
                            className={cx("ms-2", {
                                "text-disabled": !showMeta,
                                "text-muted": showMeta
                            })}
                        />
                    </div>
                ) : null}
            </Card.Header>
            <div>
                <Card.Body className={`${styles.cardBody} ms-1`}>
                    <AssetbundleDropdown
                        property={property}
                        assetbundles={allowedAssetbundles}
                        getVariantByType={getVariantByType}
                        onChange={onChange}
                    />
                </Card.Body>
            </div>
            {property.meta ? (
                <Collapse in={showMeta}>
                    <div>
                        <Card.Footer className={styles.footerInfo}>
                            {property.meta.description ? (
                                <div className="bread-text text-subtle">
                                    {property.meta.description}
                                </div>
                            ) : (
                                <span className="bread-text text-subtle">
                                    No description provided.
                                </span>
                            )}
                            {property.meta.path ? (
                                <div className="bread-text text-info">
                                    Path: {property.meta.path}
                                </div>
                            ) : null}
                        </Card.Footer>
                    </div>
                </Collapse>
            ) : null}
        </Card>
    );
};

export const AssetbundleCard = React.memo(AssetbundleCardImplementation);
